export default {
  viewFullscreen: 'مشاهده تمام صفحه',
  exitFullscreen: 'خروج از تمام صفحه',
  showMyLocation: 'نمایش موقعیت من',
  removeSelectedPoint: 'حذف نقطه انتخاب شده',
  removeSelectedPoints: 'حذف نقاط انتخاب شده',
  showPlansOnMap: 'نمایش طرح ها روی نقشه',
  hidePlansOnMap: 'عدم نمایش طرح ها روی نقشه',
  chooseThisPointAs_: 'انتخاب این نقطه به عنوان {title}',
  coordinates: 'مختصات',
  submit_: 'تایید {title}',
  extractingAddress: 'در حال استخراج آدرس ...',
  newDestination: 'مقصد جدید',
  theSelectedCoordinatesAreWithinThe_: 'مختصات انتخاب شده در محدوده {title} قرار دارد',
  position: 'موقعیت'
}
